<template>
  <a-modal :title="$t('page_organization_add_menber')" :visible="visible" @ok="() => save()" @cancel="() => cancel()">
    <ml-table
      :columns="columns"
      :dataSource="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      size="small"
      rowKey="id"
      :pagination="false"
    >
    </ml-table>
  </a-modal>
</template>
<script>
import { UserPostServiceProxy,UserOrganizationServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'

const upsp = new UserPostServiceProxy()
const uosp = new UserOrganizationServiceProxy()

export default {
  data() {
    return {
      dataSource: [],
      selectedRowKeys: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    postId: {
      type: String,
      default: ''
    },
    selectTab: {
      type: String,
      default: ''
    },
    organizationId: {
      type: String,
      default: ''
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_organization_menber_nickname'),
          dataIndex: 'name',
          key: 'name',
          ellipsis: true
        },
        {
          title: this.$t('page_organization_menber_name'),
          dataIndex: 'realName',
          key: 'realName',
          ellipsis: true
        }
      ]
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getData() {
      this.dataSource = []
      if (this.organizationId && this.selectTab == '1') {
        this.getOrganization()
      } else if (this.postId && this.selectTab == '2') {
        this.getPosition()
      }
    },
    async getOrganization() {
      const data = await (
        await uosp.getNotExistUsersForOrganization(
          1,
          {
            keyValue: '',
            organizationId: this.organizationId
          },
          -1
        )
      ).data
      if (data.records) {
        this.dataSource = data.records
      }
    },
    async getPosition() {
      const data = await (
        await upsp.getNotExistUsersForPost(
          1,
          {
            keyValue: '',
            postId: this.postId
          },
          -1
        )
      ).data
      if (data.records) {
        this.dataSource = data.records
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    save() {
      this.$emit('ok', this.selectedRowKeys);
      this.selectedRowKeys = [];
    },
    cancel() {
      this.selectedRowKeys = [];
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="less" scoped></style>
